<template>
  <v-container class="component_main">
    <v-row
      v-if="list.length > 0"
      class="ma-0 pl-10 pr-4"
      style="background-color: #d1dcea"
    >
      <v-col cols="2" class="pa-0">
        <div class="px-0 pt-3">
          <b class="pr-2">TOTAIS</b><br />
        </div>
      </v-col>
      <v-col cols="10" class="pa-0">
        <v-row class="ma-0">
         <v-spacer/>
          <v-col class="text-list text-right px-0 py-1" style="max-width:13.5%">
            <small>Valor previsto:</small><br />
            <b><span>{{ totais.total_previsto | formatPrice }}</span></b>
          </v-col>
          <v-col class="text-list text-right px-0 py-1" style="max-width:13.5%">
            <small>Valor importado:</small><br />
            <b><span style="color: rgb(50, 184, 139)">{{ totais.total_importado | formatPrice }}</span></b>
          </v-col>
          <v-col class="text-list text-right px-0 py-1" style="max-width:13.5%">
            <small>Valor Conciliado:</small><br />
            <b><span style="color: rgb(50, 184, 139)">{{ totais.total_conciliado | formatPrice }} ({{ totais.total_porcem_conciliado | formatPrice }}%)</span></b>
          </v-col>
          <v-col style="max-width:80px"></v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <div class="col-md-12">
        <v-data-table
          :headers="headers"
          :items="list"
          :items-per-page="itemsPerPage"
          :page.sync="page"
          hide-default-footer
          min="-1"
          max="15"
          @page-count="pageCount = parseInt($event, itemsPerPage)"
          @update:options="sortSelectValue" 
          dense
        >
          <template v-slot:item="props">
            <tr style="cursor: pointer" @click="selectItem(props.item.id)">
              <td class="text-center pa-0" >
                <v-tooltip v-if="props.item.complementar==true" bottom open-delay="50">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on"
                      ><v-icon class="pt-0 pr-1" size="11px" color="primary">fa-asterisk</v-icon></span>
                  </template>
                  <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">Cronograma complementar</span>
                </v-tooltip>
                <v-tooltip bottom v-if="props.item.is_atrasado">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      style="color: #fc9e0d"
                      v-bind="attrs"
                      v-on="on"
                      class="pa-0"
                    >
                     <b>{{ props.item.dt_faturamento | formatDate }}</b>
                    </span>
                  </template>
                  <span
                    class="px-3 py-1 ma-0"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    "
                    > <span >Em atraso</span>
                    </span
                  >
                </v-tooltip>
               <span v-else>
                {{ props.item.dt_faturamento | formatDate }}
               </span>
              </td>
              <td class="text-left pa-2">{{ props.item.owner_username }}</td>
              <td class="text-left pa-2">{{ props.item.prest_nome }}</td>
              <td class="text-left pa-2">{{ props.item.login_prestador }}</td>
              <td class="text-left pa-2">{{ props.item.oper_nome }}</td>
              <td class="text-left pa-2">{{ props.item.tipo_guia }}</td>
              <td class="text-right pa-2">
                {{props.item.vl_prev_faturamento | formatPrice}}
                <!-- <money
                  class="mask text-right"
                  :disabled="true"
                  v-model="props.item.vl_prev_faturamento"
                  v-bind="money"
                ></money> -->
                <!-- {{
                  new Number(props.item.vl_prev_faturamento).toFixed(2).toLocaleString(
                    "pt-BR"
                  )
                }} -->
              </td>
              <td class="text-right pa-2">
                {{props.item.arq_vl_calculado | formatPrice}}
                <!-- <money
                  class="mask text-right"
                  :disabled="true"
                  v-model="props.item.arq_vl_calculado"
                  v-bind="money"
                ></money> -->
                <!-- {{
                  new Number(props.item.arq_vl_calculado).toFixed(2).toLocaleString(
                    "pt-BR"
                  )
                }} -->
              </td>
              <td class="text-right pa-2">
                {{props.item.arq_vl_conciliado | formatPrice}} ({{props.item.calc_porcem_conciliado | formatPrice}}%)
                <!-- <money
                  class="mask text-right"
                  :disabled="true"
                  v-model="props.item.arq_vl_calculado"
                  v-bind="money"
                ></money> -->
                <!-- {{
                  new Number(props.item.arq_vl_calculado).toFixed(2).toLocaleString(
                    "pt-BR"
                  )
                }} -->
              </td>
              <td class="text-center pa-2">
                <template v-for="(status, ind) in statusList">
                  <!-- {{props.item['status']}}{{status}} -->
                  <v-tooltip
                    bottom
                    v-if="showBolinha(status, props.item[status.param])"
                    v-bind:key='ind'
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="pa-0">
                        <v-icon :color="status.cor" size="13px" class="pr-1"
                          >fas fa-circle</v-icon
                        >
                      </span>
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style="
                        border: solid 1px #999;
                        border-radius: 5px;
                        background-color: #fff;
                      "
                      >{{(status.comp==">")? props.item[status.param] + " " + status.descricao : status.descricao}}</span
                    >
                  </v-tooltip>
                </template>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div class="text-center py-0  col-md-12">
        <small>* Os lotes, pertencentes a um cronograma complementar, não serão enviados à operadora.</small>
        <br>
        <v-pagination
          class="no-box-shadow"
          v-model="pagination.current_page"
          :length="pagination.total_pages"
          @input="updateFilter(filter, pagination.current_page, 'btnPaginacao - cronogramas List')"
        ></v-pagination>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
moment.locale("pt-BR");
// import { Money } from "v-money";
export default {
  // components: { Money },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      money: {
        decimal: ",",
        thousands: ".",
        // prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      statusList: [
        { param: "status", value: "C", comp:"==", cor: "#979797", descricao: "Cronograma não iniciado"},
        { param: "status", value: "F", comp:"==", cor: "#32B88B", descricao: "Cronograma concluído"},
        { param: "qt_arq_critica", value: 0, comp:">", cor: "#D0021B", descricao: "lote(s) com crítica"},
        { param: "aguardando_conclusao", value: 0, comp:">", cor: "#B2B842", descricao: "lote(s) aguardando conclusão"},
        { param: "qt_arq_processando", value: 0, comp:">", cor: "#4A4A4A", descricao: "lote(s) em processamento"},
        { param: "qt_arq_pronto_envio", value: 0, comp:">", cor: "#FC5F17", descricao: "lote(s) aguardando transmissão"},
      ],
      // status: {
      //   A: "Aberto",
      //   C: "Criado",
      //   F: "Concluído",
      // },
      showTotal: false
    };
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  watch: {
    list(val) {
      if (val && val.length && (this.filter.prestador_id || this.filter.operadora_ans_id || this.filter.owner_id || this.filter.card_name || this.filter.complementar || this.filter.dt_faturamento_ini || this.filter.dt_faturamento_fim))
        this.showTotal = true
      else
        this.showTotal = false
    }
  },
  methods: {
    sortSelectValue(item) {
      let sort = item.sortBy[0] ? item.sortBy[0] : null;
      let order =
        item.sortDesc.length > 0 ? (item.sortDesc[0] ? "Desc": "Asc") : null;
      let newFilter = {...this.filter, sort, order}
      this.updateFilter(newFilter, 1, 'sortSelectValue');
    },
    showBolinha(status, valor) {
      let resultado = false;
      switch (status.comp) {
        case "==":
            resultado = valor == status.value;
            break;
        case ">":
            resultado = valor > status.value;
            break;
        default:
            resultado = false;
      }
      return resultado;
    }
  },
  props: {
    filterList: Function,
    updateFilter: Function,
    filter: Object,
    headers: Array,
    list: Array,
    pagination: Object,
    selectItem: Function,
    totais: Object
  },
};
</script>

<style lang="scss">
.no-box-shadow,
.no-box-shadow * {
  box-shadow: 0 0 0 0 !important;
}
.lote-erro {
  color: red;
  font-weight: bold;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  min-width: 90px;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 0 4px;
  transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
.component_main {
  .v-data-table > .v-data-table__wrapper > table > tbody > tr td:nth-child(8) {
    width: 120px;
  }
  .v-data-table > .v-data-table__wrapper > table > tbody > tr td:nth-child(9) {
    width: 90px;
  }
}

th.text-center.lotes-critica.sortable {
  min-width: 105px !important;
}

.valor-previsto {
  position: absolute;
  right: 235px; 
  font-weight: 700;
  font-size: 13px;

}
.valor-importado {
  position: absolute;
  right: 115px;
  font-weight: 700;
  font-size: 13px;
}
</style>
